// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Board.css */
.board-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: visible;
  z-index: 10; 
}

.canvas-container {
  position: absolute;
  margin-top: 37px;
  /* top и left задаются inline, а transform-origin сохраняется для вращения и масштабирования */
  transform-origin: center center;
  z-index: 100; 
}


.backing-canvas {
  position: fixed;
  touch-action: none;
  opacity: 0;
  z-index: 40; 
}

.main-canvas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center center;
  transform: translate(-50%, -50%);
  background: transparent;
  z-index: 110; 
}

.temp-canvas, .grid-canvas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center center;
  transform: translate(-50%, -50%);
  background: transparent;
  z-index: 120; 
}


.overlay-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--tg-theme-bg-color);
  opacity: 0.5;
  z-index: 1100;
}

.overlay-background.transparent {
  background-color: transparent;
}


.word, .layername {
  position: fixed;
  display: flex;
  flex-direction: row; /* элементы в ряд */
  gap: 5px; 
  left: 50%;
  margin-top: 4px;
  font-size: 22px;
  color: var(--tg-theme-text-color);
  transform: translate(-50%) translate(-5px);
  z-index: 200;
}
.word {
  transform: translate(-50%) translate(15px);
}`, "",{"version":3,"sources":["webpack://./src/components/board/Board.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8FAA8F;EAC9F,+BAA+B;EAC/B,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB,EAAE,mBAAmB;EACxC,QAAQ;EACR,SAAS;EACT,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,0CAA0C;EAC1C,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C","sourcesContent":["/* src/components/Board.css */\r\n.board-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  overflow: visible;\r\n  z-index: 10; \r\n}\r\n\r\n.canvas-container {\r\n  position: absolute;\r\n  margin-top: 37px;\r\n  /* top и left задаются inline, а transform-origin сохраняется для вращения и масштабирования */\r\n  transform-origin: center center;\r\n  z-index: 100; \r\n}\r\n\r\n\r\n.backing-canvas {\r\n  position: fixed;\r\n  touch-action: none;\r\n  opacity: 0;\r\n  z-index: 40; \r\n}\r\n\r\n.main-canvas {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform-origin: center center;\r\n  transform: translate(-50%, -50%);\r\n  background: transparent;\r\n  z-index: 110; \r\n}\r\n\r\n.temp-canvas, .grid-canvas {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform-origin: center center;\r\n  transform: translate(-50%, -50%);\r\n  background: transparent;\r\n  z-index: 120; \r\n}\r\n\r\n\r\n.overlay-background {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: var(--tg-theme-bg-color);\r\n  opacity: 0.5;\r\n  z-index: 1100;\r\n}\r\n\r\n.overlay-background.transparent {\r\n  background-color: transparent;\r\n}\r\n\r\n\r\n.word, .layername {\r\n  position: fixed;\r\n  display: flex;\r\n  flex-direction: row; /* элементы в ряд */\r\n  gap: 5px; \r\n  left: 50%;\r\n  margin-top: 4px;\r\n  font-size: 22px;\r\n  color: var(--tg-theme-text-color);\r\n  transform: translate(-50%) translate(-5px);\r\n  z-index: 200;\r\n}\r\n.word {\r\n  transform: translate(-50%) translate(15px);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
